import { useId } from 'react'
import { Props_SnippetIconsText } from './IconsText.props'
import SnippetLink from '../Shared/Link/Link'
import { CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'

const IconsText = (props: Props_SnippetIconsText) => {
    const {heading, repeatable_iconsTextContentOptions: items, snippet} = props
    
    const snippetId = useId()
    const columnCount = snippet?.columns?.value || 3
    const classHeadingVisibility: string = heading.visibility?.value ? '' : 'snippet-icons-text__heading--hidden'
    const classSnippetColumnCount = `snippet-icons-text--cols-${columnCount}`

    return (
        <section className={`snippet-icons-text ${classSnippetColumnCount}`} data-testid="icons-text-section">
            <div className="snippet-icons-text__container">
               <h2 className={`snippet-icons-text__heading ${classHeadingVisibility}`}>{heading.content.value}</h2>
                <ul className="snippet-icons-text__container-cards">
                    {items.map(({image, imageAltText, heading, content, linkHref, linkStyle, linkTarget, linkContent}, index) => (
                        <li key={`snippet-icons-text-${snippetId}-${index}`} className="snippet-icons-text__card" data-testid="icons-text-card">
                            {image?.value && <img
                                loading="lazy"
                                src={image.value}
                                alt={imageAltText?.value}
                                className="snippet-icons-text__card-icon"
                                height="150"
                                width="150"
                            ></img>}
                            <div className="snippet-icons-text__card-container-content">
                                {heading?.value && <h3 className="snippet-icons-text__card-heading">{heading.value}</h3>}
                                {content?.value && <div className="snippet-icons-text__card-content">{CompileMarkdown(content.value)}</div>}
                                {linkHref?.value && linkContent?.value && 
                                    <SnippetLink
                                        url={linkHref.value}
                                        className="snippet-icons-text__card-link"
                                        linkStyles={linkStyle?.value}
                                        target={!!linkTarget?.value}
                                        rel={linkTarget?.value ? "noopener noreferrer" : undefined}
                                    >
                                        {linkContent?.value}
                                    </SnippetLink>
                                }
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    )
}

export default IconsText
